import {useStyles} from "../miscellaneous/constants";
import AppBar from "@material-ui/core/AppBar";
import clsx from "clsx";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import React, {useState} from "react";
import Button from '@material-ui/core/Button';
import {Link} from 'react-router-dom';
import {useCookies} from "react-cookie";
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import CloseIcon from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";
import {Fade, Menu, MenuItem, MenuList} from "@material-ui/core";
import TuneIcon from '@material-ui/icons/Tune';
import {Compare, Dvr, HelpOutline, Home, ShowChart} from "@material-ui/icons";

function MyAppBar(props) {
    const classes = useStyles();
    const [cookies, setCookie, removeCookie] = useCookies(['analyzer']);
    const [open, setOpen] = React.useState(false);

    let normal = {"textDecoration": "none", "color": "white"}
    let active = {"color": "white"}

    function deconnexion() {
        removeCookie("analyzer")
    }

    const closeHelp = (e) => {
        if (e._reactName === "onKeyDown" && e.keyCode !== 27)
            return;
        setOpen(false);
    }

    function openHelp(e) {
        e.preventDefault()
        setOpen(true)
    }

    function FadeMenu() {
        const [anchorEl, setAnchorEl] = useState(null);
        const open = Boolean(anchorEl);

        const handleClick = (event) => {
            setAnchorEl(anchorEl === null ? event.currentTarget : null);
        };

        const handleClose = () => {
            setAnchorEl(null);
        };
        return null // # TODO
        return (
            <div>
                <Button
                    color="inherit"
                    id="fade-button"
                    aria-controls={open ? 'fade-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined}
                    onClick={handleClick}
                >
                    Tracks
                </Button>
                <Menu
                    id="fade-menu"
                    MenuListProps={{
                        'aria-labelledby': 'fade-button',
                    }}
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    TransitionComponent={Fade}
                >
                    <MenuItem style={{marginTop: "40px"}}><Link style={{color: 'inherit', textDecoration: "none"}}
                                                                to="/competitions/csp/csp">CSP</Link></MenuItem>
                    <MenuItem><Link style={{color: 'inherit', textDecoration: "none"}} to="/competitions/cop/cop">COP</Link></MenuItem>
                    <MenuItem><Link style={{color: 'inherit', textDecoration: "none"}} to="/competitions/cop/fast-cop">Fast COP</Link></MenuItem>
                    <MenuItem><Link style={{color: 'inherit', textDecoration: "none"}} to="/competitions/cop/parallel-cop">Parallel COP</Link></MenuItem>
                    <MenuItem><Link style={{color: 'inherit', textDecoration: "none"}} to="/competitions/csp/mini-csp">Mini CSP</Link></MenuItem>
                    <MenuItem><Link style={{color: 'inherit', textDecoration: "none"}} to="/competitions/cop/mini-cop">Mini COP</Link></MenuItem>
                </Menu>
            </div>
        );
    }
    if (cookies && cookies.analyzer)
        return (
            <div>
                <AppBar position="fixed" className={clsx(classes.appBar)}>
                    <Toolbar className={classes.toolbar}>
                        <IconButton onClick={e=>props.toggleFilters(e)}>
                            <TuneIcon/>
                        </IconButton>
                        <Typography component="h1" variant="h6" color="inherit" noWrap className={classes.title}>
                            Competition Analyzer
                            {props.competition !== undefined ? " - " + props.competition.name + " " + props.competition.track : ""}
                        </Typography>
                        <Button color="inherit">
                            <Link to={"/"} style={props.active === "home" ? active : normal}>Home</Link>
                        </Button>
                        <Button color="inherit">
                            <Link to={"/competitions"}
                                  style={props.active === "competitions" ? active : normal}>Competitions</Link>
                        </Button>
                        <Button color="inherit">
                            <Link to={"/solvers"} style={props.active === "solvers" ? active : normal}>Solvers</Link>
                        </Button>
                        <Button color="inherit" onClick={() => deconnexion()}>
                            <ExitToAppIcon></ExitToAppIcon>
                        </Button>
                    </Toolbar>
                </AppBar>

            </div>
        )


    return (
        <div>
            <AppBar position="fixed" className={clsx(classes.appBar)}>
                <Toolbar className={classes.toolbar}>

                    <Typography component="h1" variant="h6" color="inherit" noWrap className={classes.title}>
                        <IconButton onClick={props.toggleFilters}>
                            <TuneIcon style={{ color: "white" }}/>
                        </IconButton>
                        Competition Analyzer
                        {props.competition !== undefined ? " - " + props.competition.name + " - " + props.competition.track : ""}
                    </Typography>
                    {/*<Button color="inherit">
                    <Link to={"/"} style={props.active === "home" ? active : normal}>Home</Link>
                </Button>*/}

                    <FadeMenu/>
                    <Button color="inherit">
                        <Link to='/' style={normal}><IconButton><Home  style={{ color: "white" }}> </Home></IconButton></Link>
                    </Button>
                    {props.competition !== undefined ? <Button color="inherit" onClick={e => props.toggleGraph(e)}>
                        <IconButton>{props.graph ? <Dvr  style={{ color: "white" }}></Dvr> : <ShowChart  style={{ color: "white" }}></ShowChart>}</IconButton>
                    </Button> : null}
                    <Button color="inherit" onClick={e => openHelp(e)}>
                        <IconButton><HelpOutline  style={{ color: "white" }}></HelpOutline></IconButton>
                    </Button>
                </Toolbar>
            </AppBar>
            <Dialog onKeyDown={e => closeHelp(e)} open={open} fullWidth={true} maxWidth={"md"} style={{marginTop:"50px"}}>
                <DialogTitle>Help
                    <IconButton style={{float: "right", marginTop: "-5px"}} aria-label="close" onClick={e => closeHelp(e)}>
                        <CloseIcon/>
                    </IconButton></DialogTitle>
                <DialogContent>
                    <h3>Displaying results on CSP instances</h3>
                    On the left, you have a panel for applying some filters (described below) and one for selecting solvers. Once a selection is performed, you can see:
                    <ul>
                        <li>A table summarising results per solver S: number of solved instances (Solved), number of satisfiable and unsatisfiable
                            solved instances (SAT/UNSAT), number of times S is the only solver to solve an instance, number of times S is the fastest
                            solver, and finally the Par2 score of S. Note that the Virtual Best Solver (wrt the selected solvers) is also displayed.
                        </li>
                        <li>A cactus plot</li>
                        <li>A table providing detailed results per instance and per solver. For each instance, we display first its name, its number
                            of involved variables (|V|) and constraints (|C|) and its status (if known). Then, the time required by selected solvers
                            to solve the instance is displayed. Each time a solver is the best one on a given instance, its corresponding running time
                            is shown in green.
                        </li>
                    </ul>

                    Note that you can sort the tables by clicking on the column names.<br/><br/>

                    You can also compare two specific solvers in the scatter plot area. Once two solvers have been selected, the scatter plot is
                    displayed, with details made visible when hovering over a dot.


                    <h3> Displaying results on COP instances</h3>
                    On the left, you have a panel for applying some filters (described below) and one for selecting solvers. Once a selection is performed, you can see:
                    <ul>
                        <li>A table summarising results per solver S:
                            the score of S,
                            the number of times S is able to prove optimality (#Opt),
                            the number of times S finds the best bound wrt the selection while S not proving optimality and no other selected solver proving optimality (#BB1),
                            the number of times S finds the best bound wrt the selection while S not proving optimality but another selected solver proving optimaliry (#BB2).
                            The score is computed as: #Opt + #BB1 + #BB2/2.
                            The Virtual Best Solver is also displayed in the table. </li>
                        <li>
                            A cactus plot showing a proof-oriented vision (an instance is considered as solved by a solver S when it is proven to optimality), and a cactus plot showing a search-oriented vision (an instance is considered as solved when the best bound found by any solver of the selection is reached; the proof of optimality is discarded)
                        </li>
                        <li>A table providing detailed results per instance and per solver. For each instance, we display first its name, its number
                            of involved variables (|V|) and constraints (|C|), the type of its objective and the best bound found so far (if this
                            bound is known to be optimal, it is shown in green). Then, for each selected solver S, you can find the obtained bound
                            (and its score between brackets), and on the line below, the time taken to find the bound as well as the time taken to
                            prove optimality (when appropriate; in such a case, results are shown in green). By clicking on the instance name, you
                            will
                            get informations about it (type of constraints, degree of
                            variables...).
                        </li>
                        <li>Note that when you click on a line, the behaviour (sequence of found bounds) of selected solvers is ploted in a  pop-up window.
                        </li>
                    </ul>

                    <h3>Filters</h3>
                     <IconButton>
                    <TuneIcon/>
                </IconButton>Hide/Display filters.<br/>
                    Different filters can be applied to refine the presentation of results (which are then re-computed accordingly):
                    <ul>
                        <li>Problems: You can filter by family of problems and/or names (at least 2 characters are mandatory).
                        </li>
                        <li>Constraints: You can forbid one/several constraints or force all problems to contain a type of constraint(s).</li>
                        <li>For CSP, with a dedicated pair of buttons, you can select all instances or only known SAT or UNSAT ones.</li>
                        <li>For COP, with a dedicated pair of buttons, you can select all instances or only instances that must be maximized or minimized.
                        </li>
                        <li>For COP, with a dedicated pair of buttons, you can also select all instances or only open instances or instances with known optima.
                        </li>
                        <li>Expression: logical rules can be applied with respect to the number of variables (v), the number of constraints (c), the maximal domain size(d) (and, forthcoming, the maximal constraint arity (r)). For example:
                            <ul>
                                <li>v > 100: select only instances with at least 100 variables.</li>
                                <li>v > 100 && c > 1000: select only instances with at least 100 variables and 1000 constraints.</li>
                                <li>d == 2: select only binary problems.</li>
                            </ul>
                        </li>
                    </ul>
                    You can also reduce the maximum time allowed to solve an instance.
                </DialogContent>
            </Dialog>
        </div>
    )
}

export default MyAppBar;
